/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
 if (window.location.href.includes("happy-the-staffy-safari-adventure-book")) {
      window.location.href = "/"; // change this to where you want to redirect
    }
    if (window.location.href.includes("toy-treat-bundle")) {
      window.location.href = "/"; // change this to where you want to redirect
    }


    var path = window.location.pathname;

    if (path.includes('/products/christmas-bandana-free-gift')) {
      window.location.href = '/products/staffy-christmas-bandana';
    }

    if (path.includes('/products/christmas-ornament-free-gift')) {
      window.location.href = '/products/staffy-christmas-ornament';
    }

    if (path.includes('/products/holiday-stocking-free-gift')) {
      window.location.href = '/products/christmas-stocking';
    }
  // Cart redirect disabled to allow cart functionality

  // Check if URL has ?freetoy parameter
  var varID = 45047622926521;
  var urlParams = new URLSearchParams(window.location.search);
  var hasFreeToyCoupon = urlParams.has('freetoy');
  var giftLineItem = document.querySelectorAll('[data-item*="'+varID+'"]');


  if (hasFreeToyCoupon && giftLineItem.length === 0) {
    const formData = new FormData();
    document.cookie = "free_gift_added=true; path=/; max-age=" + 60 * 60 * 24 * 30;

    fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: varID, quantity: 1 })
        }).then(() => {
          lastAction = 'added';
          document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
          
        })
  }  

  // Check if URL has ?freetoy parameter
  var varID = 44462309245113;
  var urlParams = new URLSearchParams(window.location.search);
  var hasFreeToyCoupon = urlParams.has('freetreats');
  var giftLineItem = document.querySelectorAll('[data-item*="'+varID+'"]');


  if (hasFreeToyCoupon && giftLineItem.length === 0) {
    const formData = new FormData();
    document.cookie = "free_gift_added=true; path=/; max-age=" + 60 * 60 * 24 * 30;

   fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ id: varID, quantity: 1 })
})
.then(() => {
  lastAction = 'added';
  document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

  // refresh the page once after adding
  window.location.reload();
})
.catch(error => console.error('Error adding to cart:', error));

  }    


  // Check if URL has ?freetoy parameter
  var varID = 45248685179065;
  var urlParams = new URLSearchParams(window.location.search);
  var hasFreeToyCoupon = urlParams.has('mysterygift');
  var giftLineItem = document.querySelectorAll('[data-item*="'+varID+'"]');


  if (hasFreeToyCoupon && giftLineItem.length === 0) {
    const formData = new FormData();
    document.cookie = "free_gift_added=true; path=/; max-age=" + 60 * 60 * 24 * 30;


    formData.append('id', varID); // Free toy variant ID
    formData.append('quantity', 1);
    //document.querySelectorAll('.reward-block')[0].classList.add('reward-block--selectedd')

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: {
          freeGift: true,
          giftFormData: formData,
        },
        bubbles: false,
      })
    );
  }      


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/*
// Check if user has manually turned it off before
const userDisabled = localStorage.getItem('ascSwitchDisabled') === 'true';

if (!userDisabled) {
  const checkInterval = setInterval(() => {
    const switchInput = document.querySelector('.drawer--cart:not(.is-empty) .asc-widget-switch');
    if (!switchInput) return; // keep waiting until it exists

    // Auto-activate if not already on
    if (!switchInput.checked) {
      switchInput.click();
    }

    clearInterval(checkInterval);
  }, 300);
}

// Watch for manual user toggle
document.addEventListener('change', (e) => {
  if (e.target.matches('.asc-widget-switch')) {
    if (e.target.checked) {
      // User turned it on manually → remove the "disabled" flag if any
      localStorage.removeItem('ascSwitchDisabled');
    } else {
      // User turned it off intentionally → remember it
      localStorage.setItem('ascSwitchDisabled', 'true');
    }
  }
});

*/



// Shipping Protection auto-enable moved to layout/theme.liquid (hscShippingProtectionAuto v2,
// 30 Jul 2026). Two competing auto-enable scripts is what made the toggle impossible to turn
// off — there is now exactly one owner. Do not re-add an auto-enable here.

/*
const variantIdToAutoAdd = 45439255543993;
let lastAction = null; // Track last action to avoid loops

setInterval(() => {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const cartTotal = cart.total_price / 100; // Convert from cents
      const hasVariant = cart.items.some(item => item.variant_id === variantIdToAutoAdd);

      if (cartTotal > 150 && !hasVariant && lastAction !== 'added') {
        // Add variant
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantIdToAutoAdd, quantity: 1 })
        }).then(() => {
          lastAction = 'added';
          document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

        });
      } else if (cartTotal <= 150 && hasVariant && lastAction !== 'removed') {
        // Remove variant
        const item = cart.items.find(item => item.variant_id === variantIdToAutoAdd);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        }).then(() => {
          lastAction = 'removed';
          document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

        });
      }
    });
}, 1500);



}*/
